export const esUY = {
  // Common/Generic
  "common.name": "Nombre",
  "common.establishmentName": "Nombre del establecimiento",
  "common.email": "Correo electrónico",
  "common.password": "Contraseña",
  "common.country": "País",
  "common.state": "Departamento",
  "common.city": "Ciudad",
  "common.all": "Todos",
  "common.active": "Activo",
  "common.inactive": "Inactivo",
  "common.createdAt": "Creado en",
  "common.yes": "Sí",
  "common.no": "No",
  "common.add": "Agregar",
  "common.edit": "Editar",
  "common.delete": "Eliminar",
  "common.view": "Ver",
  "common.save": "Guardar",
  "common.saveNow": "Guardar ahora",
  "common.cancel": "Cancelar",
  "common.confirm": "Confirmar",
  "common.undo": "Deshacer",
  "common.close": "Cerrar",
  "common.create": "Crear",
  "common.update": "Actualizar",
  "common.search": "Buscar",
  "common.actions": "Acciones",
  "common.status": "Situación",
  "common.success": "Éxito",
  "common.error": "Error",
  "common.loading": "Cargando",
  "common.back": "Volver",
  "common.continue": "Continuar",
  "common.submit": "Enviar",
  "common.manage": "Gestionar {name}",
  "common.export": "Exportar",
  "common.download": "Descargar",
  "common.title": "Título",
  "common.establishments": "Establecimientos",
  "common.establishmentsHelper":
    "Digite al menos 3 letras para buscar el establecimiento",
  "establishmentAutocomplete.searchError":
    "Error al buscar establecimientos. Intente nuevamente.",
  "filters.title": "Filtros",
  "filters.onlyActive": "Solo activas",
  "filters.sort.default": "Ordenar",
  "filters.sort.nameAsc": "Nombre (A → Z)",
  "filters.sort.nameDesc": "Nombre (Z → A)",
  "filters.sort.createdAsc": "Creado (Más antiguo)",
  "filters.sort.createdDesc": "Creado (Más reciente)",
  "cameras.confirmTitle": "Confirmar acción",
  "cameras.confirmMessage": "¿Está seguro que desea {name}?",
  "cameras.manageDescription": "logos, música, videos del sitio...",
  "cameras.openPreviewTooltip": "Abrir vista previa",

  // Common Messages
  "messages.saveSuccess": "¡Guardado con éxito!",
  "messages.deleteSuccess": "¡Eliminado con éxito!",
  "messages.updateSuccess": "¡Actualizado con éxito!",
  "messages.createSuccess": "¡Creado con éxito!",
  "messages.loadError": "Error al cargar datos",
  "messages.saveError": "Error al guardar",
  "messages.deleteError": "Error al eliminar",
  "messages.connectionError":
    "Hubo un problema de conexión, intente nuevamente.",
  "messages.youtubeTokenExpired":
    "La conexión con YouTube expiró. Vuelva a autorizar la cuenta de YouTube en el panel administrativo e intente nuevamente.",
  "global.generic_error": "Error inesperado. Intente nuevamente.",
  "global.saved": "Guardado con éxito.",
  "global.discarded": "Cambios descartados.",
  "messages.serverError": "Error interno del servidor, intente nuevamente.",
  "messages.unsavedChanges":
    "Tiene cambios sin guardar. ¿Realmente desea salir sin guardar?",
  "messages.leaveWithoutSaving": "Salir sin guardar",
  "messages.stayOnPage": "Continuar editando",
  "errorBoundary.title": "Algo salió mal",
  "errorBoundary.body": "Ocurrió un error inesperado al cargar esta página. Intente nuevamente.",
  "errorBoundary.retry": "Intentar de nuevo",
  "messages.confirmDelete":
    "Esta acción es irreversible. ¿Desea continuar de todos modos?",
  "messages.fillRequiredFields": "Complete todos los campos obligatorios",
  "global.cancel": "Cancelar",
  "global.close": "Cerrar",
  "global.save": "Guardar",

  // Common Validations
  "validation.required": "{field} es obligatorio",
  "validation.emailRequired": "El correo electrónico es obligatorio",
  "validation.passwordRequired": "La contraseña es obligatoria",
  "validation.invalidEmail": "Correo electrónico inválido",
  "validation.passwordMismatch": "Las contraseñas no coinciden",
  "validation.passwordCriteria":
    "La contraseña no cumple con los criterios de seguridad",

  // Common Placeholders
  "placeholder.enterEmail": "Ingrese su correo electrónico",
  "placeholder.enterPassword": "Ingrese su contraseña",
  "placeholder.search": "Buscar",
  "placeholder.searchByNameOrEmail": "Buscar por nombre o email",
  //-------------
  // Login
  "login.welcome": "Bienvenido al",
  "login.adminPanel": "Panel Administrativo",
  "login.subtitle": "Gestione sus cámaras, transmisiones y suscripciones",
  "login.enterPanel": 'Ingresar al "Panel Administrativo"',
  "login.enterEmailPlaceholder": "Ingrese su correo electrónico",
  "login.enterPasswordPlaceholder": "Ingrese su contraseña",
  "login.signIn": "Ingresar",
  "login.success": "¡Inicio de sesión exitoso!",
  "login.forgotPassword": "Olvidé mi contraseña",
  "login.rememberMe": "Recordarme",
  "login.emailRequired": "El correo electrónico es obligatorio",
  "login.passwordRequired": "La contraseña es obligatoria",
  "login.invalidCredentials": "Correo electrónico o contraseña incorrectos",
  "login.tooManyAttempts": "Demasiados intentos de inicio de sesión. Espere unos minutos e intente nuevamente.",
  "login.togglePasswordVisibility": "Mostrar/ocultar contraseña",

  // Forgot Password
  "forgotPassword.title": "¿Olvidaste tu contraseña?",
  "forgotPassword.subtitle": "Te ayudaremos a restablecerla rápidamente.",
  "forgotPassword.recover": "Recuperar contraseña",
  "forgotPassword.emailPlaceholder":
    "Ingrese su email para restablecer la contraseña",
  "forgotPassword.success": "¡Email de recuperación enviado con éxito!",
  "forgotPassword.successTo": "Enviamos un enlace de recuperación a {email}.",
  "forgotPassword.sendToAnotherEmail": "Enviar a otro correo electrónico",
  "forgotPassword.spamHint": "Verifique también su carpeta de spam o basura.",
  "forgotPassword.error": "Error interno del servidor, intente nuevamente.",

  // Reset Password
  "resetPassword.title": "Restablecer Contraseña",
  "resetPassword.subtitle": "Crea una nueva contraseña segura",
  "resetPassword.newPassword": "Nueva Contraseña",
  "resetPassword.confirmPassword": "Confirmar Contraseña",
  "resetPassword.newPasswordPlaceholder": "Ingrese su nueva contraseña",
  "resetPassword.confirmPasswordPlaceholder": "Confirme su nueva contraseña",
  "resetPassword.submit": "Restablecer Contraseña",
  "resetPassword.backToLogin": "Volver al Login",
  "resetPassword.requestNewLink": "Solicitar nuevo enlace",
  "resetPassword.success": "¡Contraseña restablecida con éxito!",
  "resetPassword.error": "Error interno del servidor, intente nuevamente.",
  "resetPassword.passwordRequired": "La contraseña es obligatoria",
  "resetPassword.confirmPasswordRequired":
    "La confirmación de contraseña es obligatoria",
  "resetPassword.criteriaTitle": "Criterios de seguridad:",
  "resetPassword.min": "Mínimo {min} caracteres",
  "resetPassword.uppercase": "Al menos {min} letra mayúscula",
  "resetPassword.lowercase": "Al menos {min} letra minúscula",
  "resetPassword.digits": "Al menos {min} número",
  "resetPassword.symbols": "Al menos {min} símbolo (ej.: ! @ # $ % &)",
  "resetPassword.confirm": "Las contraseñas deben coincidir",
  "resetPassword.tokenValid": "Token válido",
  "resetPassword.checkingToken": "Verificando enlace...",
  "resetPassword.redirectingIn": "Redirigiendo en {seconds}s...",

  // Not Found
  "notFound.oops": "¡Ups!",
  "notFound.pageNotFound": "Página no encontrada",
  "notFound.forbidden":
    "No tiene permiso para acceder a esta página. Comuníquese con un administrador si cree que debería tener acceso.",
  "notFound.backToHome": "Volver al inicio",

  // Drawer / Navigation
  "drawer.dashboard": "Dashboard",
  "drawer.cameras": "Cámaras",
  "drawer.liveStreams": "Transmisiones en Vivo",
  "drawer.subscriptions": "Suscripciones",
  "drawer.visitors": "Visitantes",
  "drawer.users": "Usuarios",
  "drawer.links": "Enlaces",
  "drawer.youtubeAccounts": "Cuentas de YouTube",
  "drawer.reports": "Reportes",
  "drawer.audit": "Auditoría",
  "drawer.help": "Ayuda",
  "help.title": "Ayuda",
  "help.subtitle": "Paso a paso de los procesos del día a día.",
  "help.notes": "Avisos",
  "drawer.more": "Más",

  // Country
  "country.BR": "Brasil",
  "country.UY": "Uruguay",
  "country.PT": "Portugal",
  "country.US": "Estados Unidos",
  "country.ES": "España",

  // AppBar
  "appBar.editUser": "Editar Usuario",
  "appBar.changePassword": "Cambiar Contraseña",
  "appBar.logout": "Salir",
  "appBar.build": "Versión",
  "appBar.build.unknown": "Desconocida",

  // ChangePassword
  "changePassword.title": "Cambiar Contraseña",
  "changePassword.currentPassword": "Contraseña Actual",
  "changePassword.currentPasswordPlaceholder": "Ingrese su contraseña actual",
  "changePassword.success": "¡Contraseña cambiada con éxito!",
  "changePassword.error": "Error al cambiar la contraseña, intente nuevamente.",
  "appBar.theme.light": "Claro",
  "appBar.theme.dark": "Oscuro",
  "appBar.role.ADMIN": "Administrador",
  "appBar.role.OWNER": "Propietario",
  "appBar.role.SUPPORT": "Soporte",

  // System User Form
  "systemUserForm.success": "¡Usuario guardado con éxito!",
  "systemUserForm.error": "Error al guardar usuario.",
  "systemUserForm.searchError": "Error al buscar establecimientos",
  "systemUserForm.create": "Crear y Enviar Invitación",
  "systemUserForm.role": "Función",
  "systemUserForm.roleHelper": "Define el nivel de acceso del usuario. ADMIN: acceso total. SOPORTE: acceso de lectura y gestión. PROPIETARIO: acceso solo a sus propios establecimientos.",
  "systemUserForm.inviteInfo": "Se enviará un correo electrónico al usuario con instrucciones para definir su contraseña y activar la cuenta.",
  "systemUserForm.activeHelper": "Los usuarios inactivos no pueden acceder al sistema.",
  "systemUserForm.establishmentsHiddenHint": "El campo de establecimientos se ocultó, pero la selección anterior se mantuvo — vuelve a aparecer si elige el rol Propietario nuevamente.",

  // User Register Accept
  "userRegisterAccept.title": "Finalizar Registro",
  "userRegisterAccept.subtitle": "Defina su contraseña",
  "userRegisterAccept.description": "Ha sido invitado(a) a acceder al sistema Meulance. Defina su contraseña para activar su cuenta.",
  "userRegisterAccept.definePassword": "Defina su contraseña de acceso",
  "userRegisterAccept.newPassword": "Nueva contraseña",
  "userRegisterAccept.confirmPassword": "Confirmar contraseña",
  "userRegisterAccept.newPasswordPlaceholder": "Ingrese su nueva contraseña",
  "userRegisterAccept.confirmPasswordPlaceholder":
    "Confirme su nueva contraseña",
  "userRegisterAccept.submit": "Finalizar Registro",
  "userRegisterAccept.backToLogin": "Volver al Login",
  "userRegisterAccept.success":
    "¡Registro finalizado con éxito! Puede hacer login ahora.",
  "userRegisterAccept.error": "Error al finalizar registro",
  "userRegisterAccept.redirectHint": "Será redirigido al login en unos instantes.",
  "userRegisterAccept.invalidToken": "Token inválido o expirado",

  // Generic Form
  "genericForm.loadError": "Error al cargar datos",
  "genericForm.fillAllRequiredFields": "Complete todos los campos obligatorios",

  // Generic List
  "genericList.rowsPerPage": "Filas por página",
  "genericList.displayedRows": "{from}-{to} de {count}",
  "genericList.moreThan": "más que {to}",

  // System User
  "systemUser.title": "Usuarios",
  "systemUser.role": "Perfil",
  "systemUser.add": "Agregar usuario",
  "systemUser.edit": "Editar usuario",
  "systemUser.delete": "Eliminar usuario",
  "systemUser.createdAt": "Creado en",
  "systemUser.searchPlaceholder": "Buscar por nombre o email",
  "systemUser.sendPasswordReset":
    "Enviar email de restablecimiento de contraseña",
  "systemUser.passwordResetConfirmMessage": "¿Enviar email de restablecimiento de contraseña a {email}?",
  "systemUser.fetchError": "Error al buscar usuarios",
  "systemUser.deleteSuccess": "Usuario eliminado con éxito",
  "systemUser.passwordResetSuccess":
    "Email de restablecimiento de contraseña enviado con éxito a {email}",
  "systemUser.passwordResetError":
    "Error al enviar email de restablecimiento de contraseña",
  "systemUser.yes": "Sí",
  "systemUser.no": "No",
  "systemUser.empty": "Ningún usuario encontrado.",
  "systemUser.selectHint": "Haga clic en una fila para seleccionar",

  // Establishment Form
  "establishmentForm.title": "Establecimiento",
  "establishmentForm.success": "¡Establecimiento guardado con éxito!",
  "establishmentForm.error": "Error al guardar establecimiento.",
  "establishmentForm.create": "Registrar",
  "establishmentForm.new": "Nuevo establecimiento",
  "establishmentForm.timezone": "Zona horaria",
  "establishmentForm.channels": "Cámaras",
  "establishmentForm.channelsHint": "Cada cámara representa una cancha de este establecimiento.",
  "establishmentForm.channelsRestricted": "Solo administradores/soporte pueden gestionar cámaras.",
  "establishmentForm.channelsSaveHint":
    "Los cambios en las cámaras se guardan de inmediato al hacer clic en el ícono de guardar de cada fila — no forman parte del guardado general del formulario.",
  "establishmentForm.addChannel": "Agregar cámara",
  "establishmentForm.channelName": "Nombre de la Cámara",
  "establishmentForm.actions": "Acciones",
  "establishmentForm.confirmDeleteChannel":
    "¿Está seguro que desea eliminar esta cámara? El cambio se persistirá solo después de guardar el formulario.",
  "establishmentForm.private": "Establecimiento privado",
  "establishmentForm.manageVisitors": "Gestionar Visitantes",
  "establishmentForm.thumbnailLogoTitle": "Logo de la miniatura de las lives",
  "establishmentForm.thumbnailLogoHint": "Logo que se muestra en la miniatura de las lives de este establecimiento en el sitio (normalmente el logo del club). Sin logo, la miniatura usa la imagen de la transmisión en YouTube.",
  "establishmentForm.thumbnailLogoEmpty": "Ningún logo enviado.",
  "establishmentForm.thumbnailLogoUpload": "Enviar logo",
  "establishmentForm.thumbnailLogoReplace": "Cambiar logo",
  "establishmentForm.thumbnailLogoRemove": "Quitar logo",
  "establishmentForm.thumbnailLogoConfirmRemove": "¿Quitar el logo de la miniatura? Las lives volverán a usar la imagen de YouTube.",
  "establishmentForm.thumbnailLogoSaved": "¡Logo de la miniatura guardado!",
  "establishmentForm.thumbnailLogoRemoved": "Logo de la miniatura quitado.",
  "establishmentForm.thumbnailLogoError": "Error al guardar el logo de la miniatura.",
  "establishmentForm.thumbnailLogoTooLarge": "El archivo supera el límite de 2 MB.",
  "establishmentForm.thumbnailLogoRejected": "Archivo no aceptado. Envía una sola imagen PNG, JPEG o GIF.",

  // Logo Editor
  "logoEditor.title": "Editor de Logos",
  "logoEditor.deleteConfirmTitle": "Eliminar Logo",
  "logoEditor.deleteConfirmMessage":
    "Esta acción es irreversible. ¿Desea continuar de todos modos?",
  "logoEditor.deleteSuccess": "¡Logo eliminado con éxito!",
  "logoEditor.deleteError": "Error al eliminar logo.",
  "logoEditor.saveSuccess": "¡Logos guardados con éxito!",
  "logoEditor.saveError": "Error al guardar logos.",
  "logoEditor.loadLogosError": "Error al cargar logos.",
  "logoEditor.loadSnapshotError": "Error al cargar snapshot.",

  // Upload
  "upload.unsupportedFile": "Archivo no soportado",
  "upload.dropFiles": "Suelte los archivos aquí",
  "upload.acceptedFormats": "Formatos admitidos: PNG, JPEG, GIF",

  // Logo List
  "logoList.addLogos": "Agregue los logos",

  // Delete Dialog
  "deleteDialog.confirmMessage":
    "Esta acción es irreversible. ¿Desea continuar de todos modos?",

  // Cam Layout Editor
  "camLayoutEditor.preserveAspectRatio":
    "Mantener proporción al redimensionar los logos",
  "camLayoutEditor.undoPosition": "Deshacer última posición (Ctrl+Z)",

  // Establishment List
  "establishmentList.title": "Establecimientos",
  "establishmentList.channels": "Cámaras",
  "establishmentList.createdAt": "Fecha de Creación",
  "establishmentHashList.title": "Enlaces",
  "establishmentHashList.createLink": "Crear nuevo enlace",
  "establishmentHashList.address": "Dirección",
  "establishmentHashList.empty": "No hay enlaces registrados",
  "establishmentHashList.fetchError": "Error al buscar los establecimientos",
  "establishmentHashList.deleteSuccess": "Enlace eliminado con éxito",
  "establishmentHashList.qrCode": "Ver código QR",
  "establishmentList.searchPlaceholder": "Buscar",
  "establishmentList.toggleStatus": "Activar/Desactivar",
  "establishmentList.toggleConfirmTitle": "Activar/Desactivar establecimiento",
  "establishmentList.toggleConfirmMessage":
    "¿Está seguro que desea {action} {name}?",
  "establishmentList.enable": "Activar",
  "establishmentList.disable": "Desactivar",
  "establishmentList.createLink": "Crear Enlace",
  "establishmentList.selectHint": "Seleccione un establecimiento para crear un enlace",
  "establishmentList.fetchError": "Error al buscar los establecimientos",
  "establishmentList.statusUpdateSuccess": "Situación actualizada con éxito",
  "establishmentList.deleteSuccess": "Establecimiento eliminado con éxito",
  "establishmentList.empty": "Ningún establecimiento encontrado.",

  // Cameras
  "cameras.title": "Cámaras",
  "cameras.fetchError": "Error al obtener las cámaras",
  "cameras.noCameras": "No hay cámaras registradas",
  "cameras.noCamerasHintOperator": "Haga clic en \"Agregar\" arriba para registrar su primer establecimiento y cámaras.",
  "cameras.noCamerasHint": "No se encontró ningún establecimiento con cámaras para su usuario.",
  "cameras.replaysLabel": "Cámara activa",
  "cameras.playPreview": "Iniciar vista previa en vivo",
  "cameras.pausePreview": "Pausar vista previa en vivo",
  "cameras.streamUnavailable": "Transmisión en vivo no disponible por ahora",
  "cameras.streamReplaced": "La vista previa se interrumpió porque otra persona abrió una cámara. Inténtelo de nuevo.",
  "cameras.offlineNoPreview": "Cámara offline",
  "cameras.onlineFilterAria": "Filtrar por estado de conexión",
  "cameras.onlineFilterAll": "Todas",
  "cameras.onlineCount": "{online}/{total} online",
  "cameras.noCamerasForOnlineFilter": "No se encontraron cámaras para ese filtro.",
  "cameras.offlineSince": "Offline desde {date}",
  "cameras.streamFallbackSnapshot":
    "Mostrando el snapshot más reciente cuando esté disponible.",
  "cameras.openLegacyPreview": "Abrir cámara en vivo",
  "cameras.legacyPreviewUnavailable":
    "No fue posible obtener la URL antigua de esta cámara.",
  "cameras.toggleTooltip": "Activar/Desactivar",
  "cameras.toggleTooltipAdmin": "Solo ADMIN",
  "cameras.toggleSuccess": "Situación actualizada con éxito",
  "cameras.searchPlaceholder": "Buscar por cámara o establecimiento",
  "cameras.channelCreatedAt": "Cámara creada en {date}",
  "cameras.toggleConfirmTitle": "Activar/Desactivar pista",
  "cameras.toggleConfirmMessage": "¿Está seguro que desea {action} {name}?",
  "cameras.enable": "Activar",
  "cameras.disable": "Desactivar",

  "cameras.channelUpdatedAt": "Cámara actualizada en {date}",
  "cameras.deleteSuccess": "Pista eliminada con éxito",
  "cameras.deleteDialog.title": "Confirmar eliminación",
  "cameras.deleteDialog.titleEstablishment": "Eliminar establecimiento",
  "cameras.deleteDialog.titleChannel": "Eliminar cámara",
  "cameras.deleteDialog.titleDevice": "Eliminar dispositivo",
  "cameras.deleteDialog.messageEstablishment": "¿Está seguro de que desea eliminar el establecimiento \"{name}\"? Todos los canales y dispositivos serán removidos.",
  "cameras.deleteDialog.messageChannel": "¿Está seguro de que desea eliminar la cámara \"{name}\"?",
  "cameras.deleteDialog.messageDevice": "¿Está seguro de que desea eliminar el dispositivo \"{name}\"?",
  "cameras.deleteDialog.message":
    "Está por eliminar {name}. Esta acción no se puede deshacer.",
  "cameras.deleteDialog.warning":
    "Al confirmar, la eliminación será permanente e irreversible.",
  "cameras.deleteDialog.checkbox":
    "Confirmo que deseo eliminar y entiendo que esta acción es irreversible.",
  "cameras.deleteDialog.confirm": "Sí, eliminar",
  "deletionPreview.descriptionEstablishment":
    "Esta acción es permanente y eliminará todo lo que pertenece al establecimiento \"{name}\":",
  "deletionPreview.descriptionChannel":
    "Esta acción es permanente y eliminará todo lo que pertenece a la cámara \"{name}\":",
  "deletionPreview.rowChannels": "Canales",
  "deletionPreview.rowVideos": "Videos",
  "deletionPreview.rowLogos": "Logos",
  "deletionPreview.rowFavorites": "Favoritos de visitantes",
  "deletionPreview.rowSavedVideos": "Videos guardados por visitantes",
  "deletionPreview.typeToConfirm": "Para confirmar, escribí \"{name}\" abajo:",
  "deletionPreview.loadError":
    "No se pudo cargar lo que se va a eliminar. Intentá de nuevo.",
  "deletionPreview.confirm": "Eliminar permanentemente",
  // Cameras - Details
  "establishment.paymentBlocked.title": "Acceso bloqueado por pago atrasado",
  "establishment.paymentBlocked.message": "La suscripción de este club tiene un pago pendiente. Contactá al equipo financiero para regularizarlo y liberar el acceso de nuevo.",
  "cameras.details.title": "Detalles de la Cámara",
  "cameras.details.tabDetails": "Detalles",
  "cameras.details.subtitle":
    "Edita el nombre de la cámara y accede a configuraciones",
  "cameras.details.cameraLabel": "Cámara",
  "cameras.details.saveSuccess": "Nombre actualizado con éxito",
  "cameras.details.saveError": "Error al actualizar el nombre",
  "cameras.details.videos": "Videos del Sitio",
  "cameras.details.logos": "Logos y Música",
  "cameras.details.privateCourt": "Pista Privada",
  "cameraLogos.title": "Logos y Música",
  "cameraLogos.divergenceWarning":
    "Las cámaras de esta cancha tienen marcas de agua diferentes. Elija una configuración para usar en todas.",
  "cameraLogos.fileTooLarge":
    "Uno o más archivos superan el límite de 5MB y no fueron agregados.",
  "cameraLogos.logos": "Logos",
  "cameraLogos.musicHint": "Elige una pista y guárdala para esta cámara.",
  "cameraLogos.defaultLogoLabel": "Logo predeterminado Meu Lance",
  "cameraLogos.defaultLogoHint":
    "Controla si el logo predeterminado de Meu Lance aparece en la esquina superior izquierda.",
  "cameraLogos.defaultLogoPreviewHint":
    "La vista previa mantiene la proporción real de la transmisión. En una base de 1920 px, el logo predeterminado ocupa 276x67 px, a 60px de la izquierda y 50px del borde superior.",
  "cameraLogos.defaultLogoSaved": "Logo predeterminado actualizado",
  "cameraLogos.defaultLogoSaveError":
    "Error al actualizar el logo predeterminado",
  "cameraLogos.music": "Músicas",
  "cameraLogos.musicSaved": "Música guardada con éxito",
  "cameraLogos.musicSaveError": "Error al guardar música",
  "cameraLogos.noMusic": "Sin música",
  "cameraLogos.positionTitle": "Posicionamiento de logos",
  "cameraLogos.positionSubtitle": "Arrastra y redimensiona en la imagen base",
  "cameraLogos.libraryTitle": "Biblioteca de logos",
  "cameraLogos.librarySubtitle": "Sube, elimina y organiza tus logos",
  "logoEditor.loadingSnapshot": "Cargando snapshot...",
  "cameraPrivate.title": "Acceso Privado",
  "cameraPrivate.description":
    "Habilite el acceso privado y establezca una contraseña para restringir el acceso a esta cámara.",
  "cameraPrivate.enable": "Habilitar acceso privado",
  "cameraPrivate.password": "Contraseña",
  "cameraPrivate.passwordSetPlaceholder": "Contraseña definida — deje en blanco para mantenerla",
  "cameraPrivate.passwordSetHelper": "Ya existe una contraseña configurada. Escriba una nueva solo si desea reemplazarla.",
  "cameraPrivate.saveSuccess": "Configuración guardada con éxito",
  "cameraPrivate.authorizedTitle": "Usuarios autorizados",
  "cameraPrivate.authorizedDescription":
    "Solo los usuarios listados aquí podrán ver los videos privados.",
  "cameraPrivate.manageAuthorized": "Gestionar usuarios autorizados",
  "cameraPrivate.passwordMode": "Privar con contraseña",
  "cameraPrivate.authorizedMode": "Privar con usuarios autorizados",
  "cameraPrivate.mutuallyExclusive":
    "Solo puedes activar un método a la vez. Al activar uno, el otro se desactiva.",
  "cameraPrivate.passwordHint":
    "Define la contraseña para permitir acceso cuando este modo esté activo.",
  "cameraPrivate.save": "Guardar privacidad",
  "cameraPrivate.saveHint":
    "Guarda el modo actual (contraseña o usuarios autorizados).",
  // Create Link Dialog
  "createLinkDialog.title": "Crear enlace",
  "createLinkDialog.createButton": "Crear enlace",
  "createLinkDialog.success": "Enlace creado con éxito",
  "createLinkDialog.error": "Error al crear enlace",
  "createLinkDialog.successTitle": "Enlace creado con éxito",
  "createLinkDialog.linkLabel": "Enlace",
  "createLinkDialog.viewLinks": "Ver enlaces",
  "createLinkDialog.qrCode": "Ver código QR",
  "qrCodeDialog.title": "Código QR",
  "qrCodeDialog.alt": "Código QR del enlace",
  "qrCodeDialog.error": "No se pudo generar el código QR",
  "qrCodeDialog.download": "Descargar PNG",
  "qrCodeDialog.downloadError": "No se pudo descargar. Mantené presionada la imagen para guardarla.",
  // Confirmations
  "establishmentList.confirmDeleteTitle": "Eliminar establecimiento",
  "establishmentList.confirmDeleteMessage":
    "¿Está seguro de que desea eliminar {name}? Esta acción eliminará todas las pistas.",
  "cameras.confirmDeleteTitle": "Eliminar pista",
  "cameras.confirmDeleteMessage": "¿Está seguro de que desea eliminar {name}?",
  "video.delete_success": "Video eliminado con éxito",
  "video.delete_error": "No se pudo eliminar el video. Verifique su conexión e intente nuevamente.",
  "video.restore_success": "Video restaurado con éxito",
  "video.restore_error": "No se pudo restaurar el video. Verifique su conexión e intente nuevamente.",
  "cameraVideos.title": "Videos del Sitio",
  "cameraVideos.filters.date": "Fecha",
  "cameraVideos.filters.hour": "Hora",
  "cameraVideos.filters.allDates": "Todas las fechas",
  "cameraVideos.filters.allHours": "Todas las horas",
  "cameraVideos.filters.today": "Hoy",
  "cameraVideos.filters.status": "Estado",
  "cameraVideos.filters.active": "Activos",
  "cameraVideos.filters.inactive": "Desactivados",
  "cameraVideos.empty":
    "No se encontraron videos para los filtros seleccionados",
  "cameraVideos.emptyToday": "Todavía no hay videos hoy.",
  "cameraVideos.confirmDeleteTitle": "Eliminar video",
  "cameraVideos.confirmDeleteMessage":
    "¿Está seguro que desea eliminar el video de {name}?",
  "cameraVideos.deleteVideo": "Eliminar video",
  "cameraVideos.thumbnailAlt": "Miniatura del video",
  "cameraVideos.toggleStatus": "Activar/Desactivar video",
  "cameraVideos.confirmToggleTitle": "Activar/Desactivar video",
  "cameraVideos.confirmToggleMessage":
    "¿Está seguro que desea {action} el video de {name}?",
  "cameraVideos.enable": "activar",
  "cameraVideos.disable": "desactivar",
  "cameraVideos.tabProcessed": "Procesados",
  "cameraVideos.tabPending": "Pendientes",
  "cameraVideos.pendingWarning":
    "Solo se pueden recuperar los videos enviados en las últimas 48 horas. Los videos más antiguos ya fueron eliminados automáticamente del almacenamiento de origen.",
  "cameraVideos.pendingEmpty": "No se encontraron videos pendientes.",
  "cameraVideos.pendingLoadError": "No se pudieron cargar los videos pendientes.",
  "cameraVideos.pendingName": "Archivo",
  "cameraVideos.pendingLastModified": "Subido el",
  "cameraVideos.reprocessSelected": "Reprocesar seleccionados",
  "cameraVideos.reprocessSelectedCount": "Reprocesar {count} seleccionado(s)",
  "cameraVideos.confirmReprocessTitle": "Reprocesar videos",
  "cameraVideos.confirmReprocessMessage":
    "¿Está seguro que desea reprocesar {count} video(s)?",
  "cameraVideos.reprocessSuccess": "Reprocesamiento iniciado con éxito.",
  "cameraVideos.reprocessPartialError": "{count} video(s) fallaron al reprocesar.",
  "cameraVideos.reprocessError": "No se pudieron reprocesar los videos seleccionados.",
  "cameraVideos.pendingRefresh": "Actualizar lista",
  "cameraVideos.pendingStatus": "Estado",
  "cameraVideos.pendingStatusTriggered": "Reprocesamiento iniciado",
  "cameraVideos.pendingStatusError": "Falló al iniciar",
  // Visitors List
  "visitorsList.title": "Visitantes",
  "visitorsList.selectedCount": "{count} seleccionado(s)",
  "visitorsList.selectAll": "Seleccionar todos",
  "visitorsList.deleteManyConfirm": "¿Está seguro de que desea eliminar los {count} visitantes seleccionados?",
  "visitorsList.phone": "Teléfono",
  "visitorsList.establishment": "Establecimiento",
  "visitorsList.createdAt": "Fecha de Registro",
  "visitorsList.searchPlaceholder": "Buscar",
  "visitorsList.searchMinChars": "Ingrese al menos 3 caracteres",
  "visitorsList.exportAllHint": "Exporta la lista completa de visitantes (no respeta la selección de la tabla)",
  "visitorsList.deleteProgress": "Eliminando {done} de {total}...",
  "visitorsList.deleteSuccess": "Usuario eliminado con éxito",
  "visitorsList.enterEmail": "Ingrese un email",
  "visitorsList.exportSuccess": "Solicitud realizada",
  "visitorsList.empty": "Ningún visitante encontrado.",

  // Export Visitors Dialog
  "exportVisitorsDialog.confirmMessage": "¿Desea exportar todos los contactos?",
  "exportVisitorsDialog.explanation": "Recibirá un archivo con la lista completa de visitantes por correo electrónico en unos minutos.",
  "exportVisitorsDialog.emailPlaceholder": "Ingrese su email",

  // Establishment Visitor
  "establishmentVisitor.title": "Visitantes Permitidos",
  "establishmentVisitor.createdAt": "Fecha de Creación",
  "establishmentVisitor.emailPlaceholder": "email1@ejemplo.com",
  "establishmentVisitor.emailHelper":
    "Ingrese el email para verificar la asociación o agregar",
  "establishmentVisitor.notFoundAddHint":
    "No se encontró ningún visitante con ese email. Haga clic en Agregar para registrarlo.",
  "establishmentVisitor.modeSearch": "Buscando visitante",
  "establishmentVisitor.modeAdd": "Sin resultados — agregar nuevo visitante",
  "establishmentVisitor.selectedCount": "{count} seleccionado(s)",
  "establishmentVisitor.deleteSelected": "Eliminar seleccionados",
  "establishmentVisitor.empty": "Ningún visitante encontrado.",
  "establishmentVisitor.loadError": "Error al cargar visitantes permitidos",
  "establishmentVisitor.addSuccess": "Email agregado con éxito",
  "establishmentVisitor.addError": "Error al agregar emails",
  "establishmentVisitor.addEmailNotFound": "El email {email} todavía no tiene registro de visitante — el acceso no fue concedido. Pídele a la persona que se registre e intenta de nuevo.",
  "establishmentVisitor.deleteConfirm":
    "¿Confirma la eliminación de los siguientes emails?",
  "establishmentVisitor.deleteSuccess": "Visitantes eliminados con éxito",
  "establishmentVisitor.deleteError": "Error al eliminar visitantes",

  // Dashboard
  "dashboard.noCameras": "No se encontraron cámaras.",
  "dashboard.videoViews": "Visualización de Videos",
  "dashboard.videoDownloads": "Descargas de Videos",
  "dashboard.videos": "Videos Generados",
  "dashboard.adminTitle": "Panel de Control",
  "dashboard.ownerProfileTitle": "Perfil del Propietario",
  "dashboard.sectionOperational": "Estado de las Cámaras",
  "dashboard.sectionMetrics": "Métricas de Audiencia",
  "dashboard.sectionLives": "Transmisiones",
  "dashboard.sectionAlerts": "Alertas",
  "dashboard.noLivesToShow": "No hay transmisiones para mostrar.",
  "dashboard.noAlerts": "No hay alertas por el momento.",
  "dashboard.alertCamerasOffline": "{count} cámara(s) offline. Toca para verificar.",
  "dashboard.alertYoutubeReconnect": "Tu conexión con YouTube necesita renovarse. Toca para reconectar.",
  "dashboard.alertPaymentPending": "{count} transmisión(es) con pago pendiente. Toca para ver.",
  "dashboard.quickActionCreateLive": "Nueva transmisión",
  "dashboard.quickActionManageCameras": "Gestionar cámaras",
  "dashboard.quickActionConfigureLogos": "Configurar logos",
  "dashboard.quickActionConnectYoutube": "Conectar YouTube",
  "dashboard.quickActionScoreboard": "Acceder al marcador",
  "dashboard.filtersLabel": "Filtros",
  "dashboard.stateFilterLabel": "Estado",
  "dashboard.cityFilterLabel": "Ciudad",
  "dashboard.projectedImpressions": "Impresiones Proyectadas",
  "dashboard.cameraStatusTitle": "Estado de las Cámaras",
  "dashboard.cameraOnline": "En línea",
  "dashboard.cameraOffline": "Fuera de línea",
  "dashboard.cameraName": "Nombre",
  "dashboard.cameraStatusColumn": "Estado Cámara",
  "dashboard.cameraLastEvent": "Último Evento",
  "dashboard.cameraLastCommunication": "Última Comunicación",
  "dashboard.cameraLastCheck": "Última Verificación",
  "dashboard.cameraSdStatus": "Estado Tarjeta SD",
  "dashboard.cameraButtonStatus": "Estado Botonera",
  "dashboard.buttonOk": "OK",
  "dashboard.buttonNoShort": "Sin corto",
  "dashboard.buttonOffline": "Fuera de línea",
  "dashboard.buttonNotConfigured": "No configurado",
  "dashboard.buttonHealthBadTitle": "Botonera con problema",
  "dashboard.buttonHealthOkHint": "Botonera funcionando normalmente, sin cortocircuito detectado.",
  "dashboard.buttonHealthReasonVeryLong": "Video por encima de 5 minutos",
  "dashboard.buttonHealthReasonThreeLong":
    "3 videos consecutivos por encima de 2 minutos",
  "dashboard.buttonShortCircuit": "En corto",
  "dashboard.establishmentLabel": "Establecimiento",
  "dashboard.establishmentLabelCameras": "Establecimiento (cámaras)",
  "dashboard.establishmentLabelMetrics": "Establecimiento (métricas)",
  "dashboard.formatHelper": "Se aplica a todos los gráficos a continuación",
  "dashboard.sdFormat": "Formatear tarjeta SD",
  "dashboard.sdResetHint": "Resetear tarjeta",
  "dashboard.sdFormatConfirm":
    "¿Desea formatear la tarjeta SD de esta cámara? Esta acción puede tardar algunos minutos.",
  "dashboard.sdFormatSuccess": "Formateo solicitado.",
  "dashboard.sdFormatError": "Error al solicitar el formateo de la tarjeta SD.",
  "datePicker.month": "Mes",
  "datePicker.year": "Año",
  "datePicker.clear": "Limpiar",
  "datePicker.today": "Hoy",
  "timePicker.hour": "Hora",
  "timePicker.minute": "Minuto",
  "timePicker.now": "Ahora",
  "timePicker.period": "Período",
  "timePicker.am": "AM",
  "timePicker.pm": "PM",
  "dashboard.sdOk": "OK",
  "dashboard.sdError": "Error",
  "dashboard.statusUnknown": "N/D",
  "dashboard.daysWithoutEvent": "+{days} días sin evento",
  "dashboard.loadError": "Error al cargar datos del panel",
  "dashboard.cameraStatusPartialError": "Error al cargar el estado de {count} establecimiento(s).",
  "dashboard.cameraStatusError": "Error al cargar el estado de las cámaras.",
  "dashboard.metricsRestricted": "Las métricas de audiencia están disponibles para administradores, soporte y propietarios.",

  // Live Streams
  "liveStreams.title": "Transmisiones en Vivo",
  "liveStreams.subtitle": "{place}",
  "liveStreams.subtitleEmpty": "Seleccione un establecimiento",
  "liveStreams.tabs.schedule": "Agendamiento",
  "liveStreams.newLive": "Nueva transmisión",
  "liveStreams.stepWhereWhen": "Dónde y cuándo",
  "liveStreams.stepWhere": "Dónde",
  "liveStreams.stepConfiguration": "Configuración",
  "liveStreams.stepAudioReview": "Audio y revisión",
  "liveStreams.reviewTitle": "Resumen de la transmisión",
  "liveStreams.reviewSchedule": "Fecha/Hora:",
  "liveStreams.tabs.lives": "Historial de Transmisión",
  "liveStreams.tabs.playlists": "Playlists",
  "liveStreams.tabs.media": "Medios",
  "youtubeConnection.title": "Conexión YouTube",
  "youtubeConnection.subtitle": "Vincula tu cuenta con YouTube.",
  "youtubeConnection.prerequisitesAria": "Suscriptores en YouTube para transmisión en vivo",
  "youtubeConnection.prerequisitesInfo":
    "YouTube suele exigir al menos 50 suscriptores en el canal para habilitar transmisión en vivo. Consulta la Ayuda de YouTube por si cambian las reglas.",
  "youtubeConnection.connected": "Conectado",
  "youtubeConnection.disconnected": "Desconectado",
  "youtubeConnection.requiresReconnect": "Reconexión necesaria",
  "youtubeConnection.renewalError": "Falla temporal en la renovación",
  "youtubeConnection.lastSyncedAt": "Última sincronización: {date}",
  "youtubeConnection.reconnectPromptTitle": "Tu conexión con YouTube necesita renovarse",
  "youtubeConnection.reconnectPromptMessage":
    "La conexión de tu cuenta de YouTube caducó. Mientras no se renueve, las nuevas transmisiones pueden fallar o no estar disponibles. ¿Deseas reconectar ahora?",
  "youtubeConnection.reconnectPromptCta": "Reconectar ahora",
  "youtubeConnection.reconnectPromptLater": "Recordar más tarde",
  "youtubeConnection.connect": "Conectar cuenta",
  "youtubeConnection.renewOAuth": "Renovar vínculo",
  "youtubeConnection.refreshConnection": "Actualizar conexión",
  "youtubeConnection.reconnect": "Reconectar cuenta",
  "youtubeConnection.disconnect": "Desvincular",
  "youtubeConnection.support": "Hablar con soporte",
  "youtubeConnection.supportWhatsappMessage":
    "Hola, necesito ayuda con la conexión a YouTube en Meu Lance.",
  "youtubeConnection.blockingWarning":
    "Conecta tu cuenta de YouTube para programar transmisiones en vivo.",
  "youtubeConnection.disconnectNotice": "Cuenta de YouTube desvinculada.",
  "youtubeConnection.disconnectConfirmTitle": "¿Desvincular la cuenta de YouTube?",
  "youtubeConnection.disconnectConfirmBody":
    "Deberá volver a conectar la cuenta para programar y gestionar transmisiones desde la app.",
  "youtubeAdminAccounts.title": "Cuentas de YouTube",
  "youtubeAdminAccounts.column.channel": "Canal",
  "youtubeAdminAccounts.column.scheduleLimit": "Límite de agendamientos",
  "youtubeAdminAccounts.column.lastSyncedAt": "Última sincronización",
  "youtubeAdminAccounts.status.connected": "Conectada",
  "youtubeAdminAccounts.status.disconnected": "Desconectada",
  "youtubeAdminAccounts.status.requiresReconnect": "Reconexión necesaria",
  "youtubeAdminAccounts.status.renewalError": "Falla temporal en la renovación",
  "youtubeAdminAccounts.connect": "Conectar",
  "youtubeAdminAccounts.unlink": "Desvincular",
  "youtubeAdminAccounts.ownerManagedChip": "Propietario",
  "youtubeAdminAccounts.empty": "No hay cuentas registradas.",
  "youtubeAdminAccounts.createTitle": "Nueva cuenta de YouTube",
  "youtubeAdminAccounts.editTitle": "Editar cuenta de YouTube",
  "youtubeAdminAccounts.form.name": "Nombre",
  "youtubeAdminAccounts.form.scheduleLimit": "Límite de agendamientos",
  "youtubeAdminAccounts.form.active": "Activa",
  "youtubeAdminAccounts.createSuccess": "Cuenta creada. Hacé clic en \"Conectar\" para vincularla con Google.",
  "youtubeAdminAccounts.updateSuccess": "Cuenta actualizada.",
  "youtubeAdminAccounts.unlinkSuccess": "Cuenta desvinculada de Google.",
  "youtubeAdminAccounts.deleteSuccess": "Cuenta eliminada.",
  "youtubeAdminAccounts.unlinkConfirmTitle": "¿Desvincular esta cuenta de Google?",
  "youtubeAdminAccounts.unlinkConfirmMessage":
    "La cuenta \"{name}\" dejará de transmitir hasta que alguien la vuelva a conectar.",
  "youtubeAdminAccounts.deleteConfirmTitle": "¿Eliminar esta cuenta?",
  "youtubeAdminAccounts.deleteConfirmMessage":
    "La cuenta \"{name}\" será eliminada permanentemente. Esta acción no se puede deshacer.",
  "youtubeAdminAccounts.deactivateConfirmTitle": "¿Desactivar esta cuenta?",
  "youtubeAdminAccounts.deactivateConfirmMessage":
    "La cuenta \"{name}\" dejará de poder usarse en nuevas transmisiones (agendamientos activos ahora: {count}).",
  "liveDetails.noYoutubePoolAccountAvailable":
    "Ninguna cuenta de YouTube del pool está activa y conectada en este momento. Conectá o reactivá una cuenta antes de agendar.",
  "liveStreams.ownerScheduledNoticeTitle": "Transmisión agendada con éxito",
  "liveStreams.ownerScheduledNoticeBody":
    "Ahora solo queda esperar a que comience la transmisión. Puedes revisar los datos en esta pantalla y todavía editar lo que necesites.",
  "liveStreams.filterDescription": "Filtro por descripción",
  "liveStreams.filterDevice": "Filtro por dispositivo",
  "liveStreams.filterEstablishment": "Filtro por establecimiento",
  "liveStreams.filterHistoryStatus": "Filtro por estado",
  "liveStreams.historyStatusWaiting": "Aguardando",
  "liveStreams.historyStatusCompleted": "Completados",
  "liveStreams.filterAll": "Todos",
  "liveStreams.youtubeAccount": "Cuenta de YouTube",
  "liveStreams.youtubeAccountPlaceholder": "Seleccione la cuenta de YouTube",
  "liveStreams.youtubeAccountOwn": "Mi cuenta (conectada)",
  "liveStreams.scheduleAdminOnly":
    "La fecha y hora ya no pueden modificarse: la transmisión ya finalizó.",
  "liveStreams.ownerConfirmNotice":
    "Al confirmar, autorizás el cobro para realizar esta transmisión. La fecha y la hora ya no podrán modificarse después.",
  "liveStreams.ownerScheduleConfirmBody":
    "¿Desea confirmar el agendamiento para {place} - {court} el día {date}, a las {time}, con duración de {duration}?",
  "liveStreams.ownerScheduleSummary":
    "Agendamiento: {place} - {court} el día {date}, a las {time}, con duración de {duration}.",
  "liveStreams.ownerScheduleFieldPlaceCourt": "Establecimiento/Cancha:",
  "liveStreams.ownerScheduleFieldTime": "Hora:",
  "liveStreams.ownerScheduleFieldDuration": "Duración:",
  "liveStreams.upcomingTitle": "Próximos cambios de estado de LIVES",
  "liveStreams.name": "Nombre",
  "liveStreams.playlist": "Playlist",
  "liveStreams.period.title": "Nueva transmisión por período",
  "liveStreams.period.startDate": "Fecha de inicio",
  "liveStreams.period.endDate": "Fecha de fin",
  "liveStreams.period.dailyStartTime": "Hora de inicio",
  "liveStreams.period.dailyEndTime": "Hora de fin",
  "liveStreams.period.dailyTimeInvalid": "La hora de fin debe ser posterior a la hora de inicio.",
  "liveStreams.period.preview": "Ver resumen",
  "liveStreams.period.confirm": "Crear transmisión",
  "liveStreams.period.previewLoading": "Calculando resumen...",
  "liveStreams.period.daysCount": "{count, plural, one {# día de transmisión} other {# días de transmisión}}",
  "liveStreams.period.willSplitWarning":
    "{count, plural, one {# día supera 9 horas} other {# días superan 9 horas}} y será dividido automáticamente en Parte 1 y Parte 2.",
  "liveStreams.period.retry": "Volver a intentar",
  "liveStreams.period.giveUp": "Desistir",
  "liveStreams.period.viewDetails": "Ver detalles",
  "liveStreams.period.status.SCHEDULED": "Programado",
  "liveStreams.period.status.CREATED": "Creado",
  "liveStreams.period.status.FAILED": "Falló",
  "liveStreams.period.status.SKIPPED": "Omitido",
  "liveStreams.period.status.ABANDONED": "Desistido",
  "liveStreams.period.ownerMaxDaysExceeded": "Podés programar como máximo {days} días por período.",
  "liveStreams.period.billingAwaiting":
    "Esperando la confirmación de todos los horarios programados para liberar el pago.",
  "liveStreams.period.billingConfirmed":
    "Todos los horarios programados fueron confirmados — pago liberado.",
  "liveStreams.period.billingConfig.title": "Configurar tarifa diaria",
  "liveStreams.period.billingConfig.dailyRate": "Tarifa diaria (R$)",
  "liveStreams.period.billingConfig.invalidRate": "Ingresá un valor mayor que cero.",
  "liveStreams.status": "Estado",
  "liveStreams.nextChange": "Próximo cambio",
  "liveStreams.noUpcoming": "Sin cambios previstos",
  "liveStreams.livesTitle": "Historial",
  "liveStreams.tabUpcoming": "Próximas",
  "liveStreams.tabPast": "Anteriores",
  "liveStreams.noLives": "No se encontraron lives",
  "liveStreams.startsAt": "Inicio:",
  "liveStreams.endsAt": "Fin:",
  "liveStreams.paymentStatusLabel": "Estado del pago:",
  "liveStreams.paymentColumn": "Pago",
  "liveStreams.paymentStatusPaid": "Pagado",
  "liveStreams.paymentStatusPending": "Pendiente",
  "liveStreams.paymentStatusDirectFinance": "Directo con financiero",
  "liveStreams.paymentStatusAwaitingSchedules": "Esperando horarios",
  "liveStreams.paymentStatusUnknown": "No informado",
  "liveStreams.refreshPaymentStatus": "Actualizar pago",
  "liveStreams.paymentStatusUpdatedPaid": "Estado de pago actualizado: pagado.",
  "liveStreams.paymentStatusUpdatedPending":
    "Estado de pago actualizado: todavía pendiente.",
  "liveStreams.paymentStatusUpdatedDirectFinance":
    "Estado de pago actualizado: directo con financiero.",
  "liveStreams.selectLive": "Seleccione una live para editar",
  "liveStreams.pendingTitle": "Transmisiones Pendientes",
  "liveStreams.openLinkAdmin": "Abrir Link/Admin",
  "liveStreams.openAdmin": "Abrir Admin",
  "liveStreams.openDetails": "Detalles",
  "liveStreams.configureTitle": "Configuración",
  "liveStreams.configureSubtitle": "Personalice logos, música y marcador",
  "liveStreams.logosTitle": "Logos",
  "liveStreams.logosDesc": "Suba y posicione logos en la transmisión",
  "liveStreams.uploadLogos": "Subir logos",
  "liveStreams.bannerTitle": "Banners",
  "liveStreams.bannerDesc": "Gestione los banners de la transmisión",
  "liveStreams.manageBanners": "Gestionar banners",
  "liveStreams.startAt": "Inicio",
  "liveStreams.startTime": "Hora inicio",
  "liveStreams.endAt": "Fin",
  "liveStreams.endTime": "Hora fin",
  "liveStreams.estimatedPrice": "Valor estimado: {price}",
  "liveStreams.priceFormulaHint": "R$3 en la 1ª hora + R$2 por hora adicional, hasta R$15.",
  "liveStreams.endTimeHour": "Hora",
  "liveStreams.endTimeMinute": "Minutos",
  "liveStreams.maxTwoHoursHint": "Duración fija: 2 horas",
  "liveStreams.maxNineHoursHint":
    "La transmisión no puede superar 9 horas desde la hora de inicio.",
  "liveStreams.scoreType": "Tipo de marcador",
  "liveStreams.selectPlaceholder": "Seleccione...",
  "liveStreams.scoreSimple": "Simple",
  "liveStreams.scorePadel": "Pádel",
  "liveStreams.scoreVolley": "Vóley",
  "liveStreams.scoreCustom": "Personalizado",
  "liveStreams.musicTitle": "Música",
  "liveStreams.musicWithBackground": "Con música de fondo",
  "liveStreams.musicWithoutBackground": "Sin música",
  "liveStreams.musicPlaybackHint":
    "Las músicas se reproducirán en secuencia y se repetirán hasta el final de la transmisión.",
  "liveStreams.musicPreviewList": "Vista previa de músicas",
  "liveStreams.musicPreviewUnavailable":
    "No hay músicas disponibles para vista previa en este momento.",
  "liveStreams.playlist1": "Playlist 1",
  "liveStreams.playlist2": "Playlist 2",
  "liveStreams.playlist3": "Playlist 3",
  "liveStreams.playlist4": "Playlist 4",
  "liveStreams.playlist5": "Playlist 5",
  "liveStreams.adminLink": "Link del administrador",
  "liveStreams.adminLinkPlaceholder":
    "Copie el link para acceder al panel de administración",
  "liveStreams.advanced": "Avanzado",
  "liveStreams.templateHelp": "Seleccione un template (si está disponible)",
  "liveStreams.template": "Template",
  "liveStreams.createAndPay": "Guardar",
  "liveStreams.directFinancePayment": "Pago directo en financiero",
  "liveStreams.noTemplates":
    "No hay templates disponibles para esta selección.",
  "liveStreams.noCourts": "No hay canchas disponibles para esta selección.",
  "liveStreams.noEstablishmentsFound": "No se encontraron establecimientos.",
  "liveStreams.draftRestoredHint": "Continuando un agendamiento que había comenzado antes.",
  "liveStreams.establishmentsLoadError": "Error al cargar establecimientos. Intente de nuevo.",
  "liveStreams.disabledCreating": "Creando transmisión...",
  "liveStreams.disabledYoutubeNotConnected": "Conecta tu cuenta de YouTube primero",
  "liveStreams.disabledLoading": "Cargando...",
  "liveStreams.disabledPastStart": "Fecha/hora de inicio en el pasado",
  "liveStreams.disabledTooFar": "Fecha de inicio demasiado lejana (máx 48h)",
  "liveStreams.disabledInvalidEnd": "Hora de fin inválida (máx 9h)",
  "liveStreams.disabledSelectEstablishment": "Seleccione un establecimiento",
  "liveStreams.disabledSelectCamera": "Seleccione una cámara/cancha",
  "liveStreams.disabledSelectPlaylist": "Seleccione una playlist",
  "liveStreams.playlistRequired": "Seleccione una playlist.",
  "liveStreams.playlistAdminOnly":
    "La playlist solo puede ser modificada por un administrador.",
  "liveStreams.playlistLockedAfterBind":
    "La lista de reproducción no se puede cambiar después de vincularla a esta transmisión.",
  "liveStreams.playlistMissingMapping":
    "Este establecimiento no tiene playlist vinculada. Un administrador debe vincularla en Playlists.",
  "liveStreams.noPlaylistForEstablishment":
    "No hay una playlist vinculada para este establecimiento.",
  "liveStreams.period.startWindowHint": "El primer día solo acepta horarios a partir de {from}.",
  "liveStreams.startTooSoon": "Agende con al menos {minutes} minutos de anticipación (a partir de {time}).",
  "liveStreams.startWindowHint": "Disponible desde {from} hasta {to}.",
  "liveStreams.pastStart": "No se puede agendar en el pasado.",
  "liveStreams.startTooFar":
    "Solo puede agendar con hasta {hours} horas de anticipación.",
  "liveStreams.invalidRange": "Rango inválido.",
  "liveDetails.onlyWaitingOrRunningSchedulesEditable":
    "Solo las transmisiones en espera o en curso pueden editarse.",
  "liveDetails.scheduleNotIdentified": "No fue posible identificar el horario para editar.",
  "liveStreams.scheduleConflictPeriod":
    "El establecimiento y la cancha seleccionados ya tienen un agendamiento dentro del período elegido.",
  "liveStreams.mockCreated":
    "Agendamiento simulado localmente para pruebas (backend no disponible).",
  "liveStreams.minDuration": "Duración mínima: {minutes} min.",
  "liveStreams.maxDuration": "Duración máxima: {minutes} min.",

  // Live Status
  "liveStatus.waitStart": "Programado",
  "liveStatus.started": "Iniciado",
  "liveStatus.finished": "Finalizado",
  "liveStatus.failed": "Falló",
  "liveStatus.canceled": "Cancelado",

  // Live Payment
  "livePayment.title": "Pago",
  "livePayment.subtitle": "Complete el pago para finalizar la transmisión",
  "livePayment.pending": "Pendiente",
  "livePayment.billedValueLabel": "Valor cobrado",
  "livePayment.paidAtLabel": "Fecha de pago",
  "livePayment.paymentMethodLabel": "Forma de pago",
  "livePayment.back": "Volver",
  "livePayment.pay": "Pagar ahora",
  "livePayment.continue": "Continuar",
  "livePayment.autoContinueToast": "¡Pago confirmado! Finalizando la reserva...",
  "livePayment.autoContinueCountdown": "Redirigiendo en {seconds}s...",
  "livePayment.cancelAutoContinue": "Cancelar redirección automática",
  "livePayment.paymentPendingHint":
    "Pago pendiente. Puede abrir Mercado Pago para finalizarlo.",
  "livePayment.checkingPayment": "Verificando pago...",
  "livePayment.noPaymentYet": "El pago aún no se realizó.",
  "livePayment.paymentConfirmed": "Pago confirmado.",
  "livePayment.noPaymentRequired": "No se requiere pago. Puede continuar.",
  "livePayment.hint":
    "Después del pago, será redirigido para configurar la transmisión.",
  "livePayment.fallbackName": "Transmisión",
  "livePayment.fallbackPlace": "Establecimiento",
  "livePayment.fallbackDevice": "Cámara",
  "livePayment.openInNewTabHint":
    "Si no aparece el botón de pago, use el enlace para abrir el checkout en una nueva pestaña.",
  "livePayment.openInNewTab": "Abrir checkout en nueva pestaña",
  "livePayment.verifyPayment": "Ya pagué",
  "livePayment.statusRefunded":
    "El pago anterior fue reembolsado. Realice un nuevo pago.",
  "livePayment.statusRejected":
    "El pago fue rechazado. Intente nuevamente o use otro método de pago.",
  "livePayment.statusCancelled":
    "El pago fue cancelado. Realice un nuevo pago.",
  "livePayment.statusInProcess": "Pago en proceso. Espere la confirmación.",
  "livePayment.statusInMediation":
    "Pago en revisión. Contacte a Mercado Pago si necesita ayuda.",
  "livePayment.statusChargedBack":
    "Hubo un contracargo. Realice un nuevo pago.",

  // Live Link
  "liveLink.title": "Transmisión",
  "liveLink.subtitle": "Enlace de administrador para configurar la transmisión",
  "liveLink.adminLinkTitle": "Enlace del administrador",
  "liveLink.adminLinkPlaceholder":
    "El enlace estará disponible después de crear la transmisión",
  "liveLink.adminLinkHint":
    "Use este enlace para abrir el panel y configurar logos, música y marcador.",
  "liveLink.openNarratorPanel": "Abrir panel de administrador",

  "liveBranding.schedulingTitle": "Configurando transmisión",
  "liveBranding.schedulingBody":
    "Estamos preparando video, logos y conexión de la cámara. Esto puede tardar unos segundos.",
  "liveBranding.ownerPaymentTitle": "Confirmación",
  "liveBranding.ownerPaymentConfirm": "Confirmar",
  "liveBranding.ownerPaymentConfirmed":
    "Solicitud enviada. Nuestro equipo se pondrá en contacto para procesar el cobro.",

  // Live Admin
  "liveAdmin.title": "Admin de la Transmisión",
  "liveAdmin.subtitle": "Gestione marcador, banners, logos y música",
  "liveAdmin.subtitleWithLive": "{name} · {device} · {start} → {end}",
  "liveAdmin.openYoutube": "Abrir en YouTube",
  "liveAdmin.scoreTitle": "Marcador",
  "liveAdmin.team1": "Equipo 1",
  "liveAdmin.team2": "Equipo 2",
  "liveAdmin.bannersTitle": "Banners",
  "liveAdmin.bannersSubtitle":
    "Seleccione un banner para mostrar en la transmisión",
  "liveAdmin.loopingMode": "Modo rotación automática",
  "liveAdmin.on": "Encendido",
  "liveAdmin.off": "Apagado",
  "liveAdmin.narrationTitle": "Narración",
  "liveAdmin.micStatus": "Micrófono: {status}",
  "liveAdmin.toggleMic": "Alternar micrófono",
  "liveAdmin.startNarration": "Iniciar narración",
  "liveAdmin.stopNarration": "Detener narración",
  "liveAdmin.narrationHint": "La narración es un placeholder por ahora.",
  "liveAdmin.logosTitle": "Logos",
  "liveAdmin.onboardingHint": "1. Suba su logo en la biblioteca a la derecha → 2. Arrastre a la posición deseada en el cuadro de arriba → 3. Haga clic en \"Guardar\".",
  "liveAdmin.musicSectionTitle": "Música de fondo",
  "liveAdmin.unsavedChanges": "Cambios sin guardar",
  "liveAdmin.selectLogo": "Seleccionar logo para editar",
  "liveAdmin.addLogo": "Agregar logo",
  "liveAdmin.newLogo": "Nuevo logo…",
  "liveAdmin.deleteLogo": "Quitar logo",
  "liveAdmin.addLogoTitle": "Agregar logo",
  "liveAdmin.add": "Agregar",
  "liveAdmin.cancel": "Cancelar",
  "liveAdmin.image": "Imagen",
  "liveAdmin.searchImage": "Buscar imagen…",
  "liveAdmin.searchPlaylist": "Buscar playlist…",
  "liveAdmin.position": "Posición",
  "liveAdmin.position.TOP_LEFT": "Arriba izquierda",
  "liveAdmin.position.TOP_RIGHT": "Arriba derecha",
  "liveAdmin.position.BOT_LEFT": "Abajo izquierda",
  "liveAdmin.position.BOT_RIGHT": "Abajo derecha",
  "liveAdmin.offsetX": "Offset X",
  "liveAdmin.offsetY": "Offset Y",
  "liveAdmin.saveLogo": "Guardar logo",
  "liveAdmin.saveAllLogos": "Guardar",
  "liveAdmin.saveLogosConfirmTitle": "¿Guardar logos?",
  "liveAdmin.saveLogosConfirmBody":
    "Cambiaste configuraciones de logos. ¿Querés guardar antes de guardar la playlist?",
  "liveAdmin.continueWithoutSavingLogos": "Guardar playlist sin guardar logos",
  "liveAdmin.saveLogosAndContinue": "Guardar logos y guardar playlist",
  "liveAdmin.emptyLogoError":
    "Seleccioná una imagen o eliminá el logo vacío antes de guardar.",
  "liveAdmin.reservedArea": "Área reservada (publicidad)",
  "liveAdmin.cameraView": "Vista de Cámara",
  "liveAdmin.dragHint":
    "Consejo: arrastra el logo para ajustar su posición en el video. También podés aumentar o disminuir el tamaño del logo.",
  "liveAdmin.musicTitle": "Música",
  "liveAdmin.playlist": "Playlist",
  "liveAdmin.savePlaylist": "Guardar playlist",
  "liveAdmin.uploadLogoMedia": "Subir medio para logo",

  // Live Playlists
  "livePlaylists.title": "Playlists",
  "livePlaylists.add": "Nueva playlist",
  "livePlaylists.establishment": "Establecimiento",
  "livePlaylists.id": "ID",
  "livePlaylists.name": "Descripción",
  "livePlaylists.youtubeId": "YouTube ID",
  "livePlaylists.youtubeHint":
    "Deje en blanco para crear en YouTube automáticamente.",
  "livePlaylists.youtubeAccountId": "Cuenta de YouTube",
  "livePlaylists.youtubeAccountIdHint": "Elegí la cuenta que será dueña de esta playlist en YouTube.",
  "livePlaylists.filterYoutubeAccount": "Filtrar por cuenta de YouTube",
  "livePlaylists.youtubeAccountColumn": "Cuenta de YouTube",
  "livePlaylists.actions": "Acciones",
  "livePlaylists.empty": "No hay playlists registradas.",
  "livePlaylists.createTitle": "Crear playlist",
  "livePlaylists.editTitle": "Editar playlist",
  "livePlaylists.save": "Guardar",
  "livePlaylists.cancel": "Cancelar",

  // Live Media Library
  "liveMedia.title": "Medios",
  "liveMedia.upload": "Subir medio",
  "liveMedia.empty": "No hay medios registrados.",

  // Live Details
  // Live Workspace
  "liveWorkspace.tabs.detalhes": "Detalles",
  "liveWorkspace.tabs.pagamento": "Pago",
  "liveWorkspace.tabs.branding": "Logos/Músicas",
  "liveWorkspace.tabs.placar": "Marcador",
  "liveWorkspace.comingSoon": "Próximamente en esta pestaña.",

  "liveDetails.title": "Detalles de la Transmisión",
  "liveDetails.scoreboardButton": "Marcador",
  "liveDetails.back": "Volver",
  "liveDetails.openBranding": "Logos/Música",
  "liveDetails.payRequiredToConfigure":
    "Pague la transmisión para acceder a logos y configurar.",
  "liveDetails.scheduleChangeDuringStreamHint": "Los cambios de agendamiento durante la transmisión pueden requerir un reinicio para aplicarse de inmediato.",
  "liveDetails.restartDialogTitle": "Cambio durante la transmisión",
  "liveDetails.restartDialogBody": "Para que los cambios ocurran durante la transmisión, será necesario reiniciar. ¿Desea reiniciar ahora o más tarde?",
  "liveDetails.restartLater": "Reiniciar más tarde",
  "liveDetails.restartNow": "Reiniciar ahora",
  "liveDetails.tabs.overview": "General",
  "liveDetails.tabs.schedules": "Agendamientos",
  "liveDetails.tabs.emails": "Emails",
  "liveDetails.tabs.service": "Servicio",
  "liveDetails.name": "Nombre",
  "liveDetails.privacy": "Privacidad",
  "liveDetails.privacyPublic": "Público",
  "liveDetails.privacyUnlisted": "No listado",
  "liveDetails.privacyPrivate": "Privado",
  "liveDetails.privacyPublicHint": "Cualquier persona puede encontrar y ver esta transmisión.",
  "liveDetails.privacyUnlistedHint": "Solo quien tenga el enlace puede verla; no aparece en búsquedas.",
  "liveDetails.privacyPrivateHint": "Solo las personas autorizadas por usted pueden verla.",
  "liveDetails.enableAudio": "Habilitar audio",
  "liveDetails.backgroundMusic": "Música de fondo",
  "liveDetails.yes": "Sí",
  "liveDetails.no": "No",
  "liveDetails.save": "Guardar",
  "liveDetails.saveConfig": "Guardar",
  "liveDetails.discardChanges": "Descartar cambios",
  "liveDetails.status": "Estado",
  "liveDetails.playlist": "Playlist",
  "liveDetails.youtubeKeyId": "ID de la clave de YouTube",
  "liveDetails.youtubeKey": "Clave de YouTube",
  "liveDetails.dropletId": "Droplet ID",
  "liveDetails.paid": "Pagado",
  "liveDetails.device": "Local/Dispositivo",
  "liveDetails.paymentPreference": "Preferencia de pago",
  "liveDetails.billedValue": "Valor cobrado",
  "liveDetails.paidLastStatus": "Último estado del pago",
  "liveDetails.initiatedByEmail": "Iniciado por (email)",
  "liveDetails.initiatedByRole": "Iniciado por (perfil)",
  "liveDetails.schedulesTitle": "Agendamientos",
  "liveDetails.addSchedule": "Agregar agendamiento",
  "liveDetails.editSchedule": "Editar agendamiento",
  "liveDetails.scheduleStartedDateLocked":
    "Esta transmisión ya está en vivo — solo se puede cambiar la descripción.",
  "liveDetails.appendDescription": "Descripción",
  "liveDetails.startAt": "Inicio",
  "liveDetails.endAt": "Fin",
  "liveDetails.cancel": "Cancelar",
  "liveDetails.create": "Crear",
  "liveDetails.edit": "Editar",
  "liveDetails.delete": "Eliminar",
  "liveDetails.deleteScheduleTitle": "Eliminar agendamiento",
  "liveDetails.deleteScheduleMessage": "¿Está seguro de que desea eliminar este agendamiento de transmisión? Esta acción no se puede deshacer.",
  "liveDetails.deleteScheduleMessageStarted":
    "Esta transmisión ya está en vivo. Eliminar este agendamiento cancela la transmisión en YouTube ahora mismo. Esta acción no se puede deshacer.",
  "liveDetails.deleteLive": "Eliminar transmisión",
  "liveDetails.deleteLiveTitle": "Eliminar transmisión",
  "liveDetails.deleteLiveMessage": "¿Está seguro de que desea eliminar esta transmisión y todos sus agendamientos? Esta acción no se puede deshacer.",
  "liveDetails.noSchedules": "No se encontraron agendamientos.",
  "liveDetails.scheduleStatus": "Estado",
  "liveDetails.emailsTitle": "Emails",
  "liveDetails.email": "Email",
  "liveDetails.add": "Agregar",
  "liveDetails.remove": "Quitar",
  "liveDetails.noEmails": "No hay emails registrados.",
  "liveDetails.serviceTitle": "Servicio",
  "liveDetails.toggleDroplet": "Iniciar/Detener servicio",
  "liveDetails.restartService": "Reiniciar servicio",
  "liveDetails.viewLogs": "Ver logs",
  "liveDetails.logsTitle": "Logs",
  "liveDetails.close": "Cerrar",
  "liveDetails.adminOnlyService":
    "Solo administradores pueden iniciar/reiniciar el servicio y ver logs.",

  "liveService.title": "Iniciar transmisión",
  "liveService.startStream": "Iniciar transmisión",
  "liveService.stopStream": "Finalizar transmisión",
  "liveService.autoLogs": "Actualizar logs",
  "liveService.autoLogsHint": "actualizando…",
  "liveService.logsPlaceholder": "Sin logs todavía.",
  "liveService.logsNotAvailable":
    "Logs no disponibles para este servicio (droplet no encontrado).",
  "liveService.starting": "Iniciando transmisión…",
  "liveService.stopping": "Deteniendo transmisión…",
  "liveService.restarting": "Reiniciando servicio…",
  "liveService.refreshFailed": "Acción aplicada, pero no se pudo actualizar el estado en pantalla. Actualice la página.",
  "liveService.brandingSavedRestartFailed": "Configuración guardada, pero no se pudo reiniciar la transmisión para aplicarla ahora. Reinicie manualmente si es necesario.",
  "liveService.notStarted":
    "El servicio no inició. Revise el backend (droplet/logs).",
  "liveService.finishedHint":
    "Transmisión finalizada. Para iniciar de nuevo, cree una nueva transmisión.",

  // Live Scoreboard
  "liveScoreboard.pageTitle": "Marcador de la transmisión",
  "liveScoreboard.pageSubtitle":
    "Frontend del marcador para la operación de la live.",
  "liveScoreboard.liveFallback": "Marcador de la transmisión",
  "liveScoreboard.liveFallbackWithId": "Transmisión #{id}",
  "liveScoreboard.simpleFlowHint":
    "Configuración del marcador sincronizada con la transmisión.",
  "liveScoreboard.saveSuccess": "Configuración del marcador guardada.",
  "liveScoreboard.saveWarning":
    "No fue posible guardar en backend ahora. Preferencia aplicada localmente.",
  "liveScoreboard.emptyNamesError": "Complete los nombres del marcador antes de guardar.",
  "liveScoreboard.saveBeforeGenerateLinkWarning":
    "No fue posible guardar la configuración del marcador antes de generar el link del administrador.",
  "liveScoreboard.logoFallback": "Logo",
  "liveScoreboard.overlayName": "Marcador",
  "liveScoreboard.defaultLogoName": "Meu Lance",
  "liveScoreboard.overlay.teamA": "• EQUIPO A",
  "liveScoreboard.overlay.teamB": "EQUIPO B",
  "liveScoreboard.overlay.pointHeader": "PUNTOS",
  "liveScoreboard.overlay.primaryHeader": "GAMES",
  "liveScoreboard.overlay.scoreHeader": "SCORE",
  "liveScoreboard.overlay.pointShort": "PTS",
  "liveScoreboard.overlay.setShort": "SETS",
  "liveScoreboard.configTag": "AGENDAMIENTO / CONFIGURACIÓN",
  "liveScoreboard.configTitle": "Activar marcador en la transmisión",
  "liveScoreboard.configDescription":
    "Al crear la live, el dueño del club elige el deporte. Después de eso, el sistema genera automáticamente el link de administrador para operar el marcador en vivo.",
  "liveScoreboard.broadcastLabel": "Marcador en la transmisión",
  "liveScoreboard.enabled": "Activado",
  "liveScoreboard.disabled": "Desactivado",
  "liveScoreboard.toggleLabel": "Incluir marcador en la visión de la cámara",
  "liveScoreboard.musicToggleLabel": "Incluir música de fondo en la transmisión",
  "liveScoreboard.savingHint": "Guardando preferencia del marcador...",
  "liveScoreboard.sportTypeLabel": "Deporte del marcador",
  "liveScoreboard.sport.football": "Fútbol",
  "liveScoreboard.sport.padel": "Pádel",
  "liveScoreboard.sport.beachTennis": "Beach Tennis",
  "liveScoreboard.generateAdminLink": "Generar link del administrador",
  "liveScoreboard.adminLinkLabel": "Link del administrador",
  "liveScoreboard.adminTag": "ADMINISTRADOR / {sport}",
  "liveScoreboard.adminPanelTitle": "Panel del marcador",
  "liveScoreboard.adminFootballDescription":
    "El funcionario del club abre el link y controla todo solo con los botones de más y menos.",
  "liveScoreboard.adminPadelDescription":
    "También funciona solo con más y menos. El sistema entiende la progresión del punto automáticamente.",
  "liveScoreboard.adminBeachDescription":
    "Mismo comportamiento del pádel, manteniendo la operación simple y rápida durante la transmisión.",
  "liveScoreboard.enableToEdit":
    "Active el marcador en la transmisión para liberar edición.",
  "liveScoreboard.team1Upper": "EQUIPO 1",
  "liveScoreboard.team2Upper": "EQUIPO 2",
  "liveScoreboard.teamA": "Equipo A",
  "liveScoreboard.teamB": "Equipo B",
  "liveScoreboard.matchTime": "Tiempo del partido",
  "liveScoreboard.liveNow": "En vivo",
  "liveScoreboard.matchTimeLive": "{time} ({status})",
  "liveScoreboard.pair1Upper": "DUPLA 1",
  "liveScoreboard.pair2Upper": "DUPLA 2",
  "liveScoreboard.games": "Games",
  "liveScoreboard.sets": "Sets",
  "liveScoreboard.currentPoint": "Punto actual",
  "liveScoreboard.ruleHintPadel":
    "Ejemplo de regla automática: si está en 15 y toca en más, avanza a 30. Tocando de nuevo, va a 40.",
  "liveScoreboard.youtubeTitle": "Pantalla en YouTube - {sport}",
  "liveScoreboard.setLabel": "SET {set}",
  "liveScoreboard.summaryLine":
    "Sets: {setsA} x {setsB} | Punto: {pointA} x {pointB}",
  "liveScoreboard.adminLinkSaved": "Configuración del link del administrador guardada con éxito.",
  "liveScoreboard.adminLinkWarning":
    "Este link será usado por terceros sin acceso a la plataforma. Compartí el link y el código de acceso solo con quien operará el marcador de este partido.",
  "liveScoreboard.adminAccessCodeLabel": "Código de acceso",
  "liveScoreboard.adminAccessCodeNotRecoverable":
    "El código no se puede volver a mostrar. Generá un nuevo link para definir otro código.",
  "liveScoreboard.adminAccessCodeHelp":
    "Hasta 8 caracteres (letras y números). Si queda vacío, se genera automáticamente.",
  "liveScoreboard.generateRandomCode": "Generar código aleatorio",
  "liveScoreboard.adminLinkModalTitle": "Configurar link del administrador",
  "liveScoreboard.saveAdminLinkConfig": "Guardar configuración del link del administrador",
  "liveScoreboard.adminLinkExpirationLabel": "Expiración del link",
  "liveScoreboard.adminLinkExpirationFallback": "Expira 5 minutos después del fin de la transmisión.",
  "liveScoreboard.adminLinkExpirationValue": "Expiración del link: {dateTime}",
  "liveScoreboard.public.accessCodeLabel": "Código de acceso",
  "liveScoreboard.public.accessCodeHelp": "Ingresá el código de acceso recibido con el link.",
  "liveScoreboard.public.unlock": "Acceder al marcador",
  "liveScoreboard.public.operatorTag": "OPERADOR DEL MARCADOR",
  "liveScoreboard.public.liveFallback": "Marcador de la transmisión",
  "liveScoreboard.public.invalidLink": "Link inválido. Verificá el código de acceso.",
  "liveScoreboard.public.disabledForLive": "Marcador desactivado para esta transmisión.",
  "liveScoreboard.public.expired":
    "Esta transmisión ya finalizó. Este link expiró y el acceso público al marcador termina 5 minutos después del fin de la transmisión.",
  "liveScoreboard.public.accessDenied":
    "Acceso denegado. El marcador está desactivado o el código es inválido.",
  "liveScoreboard.public.accessUnavailable":
    "No fue posible acceder a este marcador con los datos informados.",
  "liveScoreboard.public.saveRetryable":
    "No fue posible guardar ahora. Intente nuevamente.",
  "liveScoreboard.public.notFound": "Link de operador no encontrado.",
  "liveScoreboard.public.loadError": "No fue posible cargar este marcador ahora.",
  "liveScoreboard.public.expiredSave": "Link expirado. Ya no se puede actualizar este marcador.",

  // Notifications
  "notifications.title": "Notificaciones",
  "notifications.noIssues": "No se encontraron problemas",
  "notifications.issueItem": "{establishment}: {device} — {reasons}",
  "notifications.reason.OFFLINE": "Cámara fuera de línea",
  "notifications.reason.SD_CARD_ERROR": "Tarjeta SD con error",
  "notifications.reason.BUTTON_SHORT_CIRCUIT": "Botonera en corto",

  // Metric Chart
  "metricChart.channel": "Cámara",
  "metricChart.total": "Total",
  "metricChart.grandTotal": "Total General",
  "metricChart.loadError": "Error al cargar métricas",
  "metricChart.errorState": "No fue posible cargar las métricas ahora. Inténtelo nuevamente en unos instantes.",
  "metricChart.showAll": "Mostrar todas (+{count})",
  "metricChart.showLess": "Mostrar menos",
  "metricChart.noData": "No se encontraron datos.",
  "metricChart.metricsOmitted":
    "{count} métricas omitidas. Mejore los filtros para visualizar datos específicos.",

  // Analytics Reporter (legado)
  "analyticsReporter.title": "Reporte de Analytics",
  "analyticsReporter.startDate": "Fecha Inicial",
  "analyticsReporter.endDate": "Fecha Final",
  "analyticsReporter.search": "Buscar establecimiento",
  "analyticsReporter.eventType": "Tipo de Evento",
  "analyticsReporter.generate": "Generar Reporte",
  "analyticsReporter.total": "Total",
  "analyticsReporter.establishment": "Establecimiento",
  "analyticsReporter.action": "Acción",
  "analyticsReporter.count": "Cant",
  "analyticsReporter.errorMaxDays": "El intervalo de fechas no puede exceder {maxDays} días.",
  "analyticsReporter.loading": "Cargando...",
  "analyticsReporter.noData": "No se encontraron datos.",
  "analyticsReporter.generating": "Generando reporte...",
  "analyticsReporter.errorFetch": "Error al obtener reporte.",

  // Analytics V2
  "analyticsV2.title": "Reportes",
  "analyticsV2.startDate": "Fecha Inicial",
  "analyticsV2.endDate": "Fecha Final",
  "analyticsV2.metric": "Métrica",
  "analyticsV2.format": "Formato",
  "analyticsV2.table": "Tabla",
  "analyticsV2.chart": "Gráfico",
  "analyticsV2.granularity": "Granularidad",
  "analyticsV2.daily": "Diario",
  "analyticsV2.monthly": "Mensual",
  "analyticsV2.total": "Total",
  "analyticsV2.groupBy": "Agrupar por:",
  "analyticsV2.court": "Cancha",
  "analyticsV2.all": "Todos",
  "analyticsV2.generateReport": "Generar Reporte",
  "analyticsV2.totalEvents": "Total de eventos: {total}",
  "analyticsV2.chartNotAvailable":
    "Gráfico no disponible para granularidad Total. Use formato Tabla.",
  "analyticsV2.establishment": "Establecimiento",
  "analyticsV2.channel": "Canal",
  "analyticsV2.event": "Evento",
  "analyticsV2.quantity": "Cantidad",
  "analyticsV2.date": "Fecha",
  "analyticsV2.noDataFound": "No se encontraron datos.",
  "analyticsV2.selectMetric": "Seleccione una métrica",
  "analyticsV2.selectEstablishment": "Seleccione al menos un establecimiento",
  "analyticsV2.reportError": "Error al generar reporte",
  "analyticsV2.download": "Descargar CSV",
  "analyticsV2.downloadError": "Error al descargar reporte",
  "analyticsV2.reportTitle": "Reporte - {metric}",
  "analyticsV2.period": "Período: {start} ~ {end}",
  "analyticsV2.description": "Descripción",

  // Metrics
  "metrics.custom_downloaded_video_2": "Descarga de Video",
  "metrics.custom_played_video_2": "Visualización de Video",
  "metrics.video_statistics": "Estadísticas de Video",
  "metrics.custom_whatsapp_opening": "Apertura de WhatsApp",
  "metrics.scroll": "Desplazamiento",
  "metrics.custom_played_live": "Visualización de Live",
  "metrics.custom_sponsor_banner": "Banner del Patrocinador",
  "metrics.custom_prospectpro_banner": "Banner del patrocinador",
  "metrics.custom_prospectpro_popup": "Popup del patrocinador",
  "metrics.custom_deixacomochef_banner": "Banner del Deixa Com o Chef",
  "metrics.custom_deixacomochef_popup": "Popup del Deixa Com o Chef",
  "metrics.page_view": "Visualización de Página",
  "metrics.custom_instagram_opening": "Apertura de Instagram",
  "metrics.click": "Clic",
  "metrics.session_start": "Inicio de Sesión",
  "metrics.first_visit": "Primera Visita",
  "metrics.user_engagement": "Compromiso del Usuario",
  "metrics.file_download": "Descarga de Archivo",

  // Subscriptions Dashboard
  "subscriptions.title": "Suscripciones",
  "subscriptions.activeSubscriptions": "Suscripciones Activas",
  "subscriptions.cancelledSubscriptions": "Suscripciones Canceladas",
  "subscriptions.expiredSubscriptions": "Suscripciones Expiradas",
  "subscriptions.singlePurchases": "Compras Únicas",
  "subscriptions.subscriptionRevenueCollected": "Ingresos Recibidos (Suscripciones)",
  "subscriptions.subscriptionRevenueTrial": "En Prueba (proyectado, no recibido)",
  "subscriptions.singleRevenue": "Ingresos Compras Únicas",
  "subscriptions.totalRevenue": "Ingresos Totales Recibidos",
  "subscriptions.noRecords": "Ningún registro encontrado.",
  "subscriptions.searchPlaceholder": "Buscar por nombre o e-mail...",
  "subscriptions.filterType": "Tipo",
  "subscriptions.filterStatus": "Estado",
  "subscriptions.filterOffering": "Producto",
  "subscriptions.filterStartDate": "Fecha Inicio",
  "subscriptions.filterEndDate": "Fecha Fin",
  "subscriptions.columnName": "Nombre",
  "subscriptions.columnEmail": "E-mail",
  "subscriptions.columnType": "Tipo",
  "subscriptions.columnOffering": "Producto",
  "subscriptions.columnAmount": "Valor",
  "subscriptions.columnStatus": "Estado",
  "subscriptions.columnDate": "Fecha",
  "subscriptions.columnNextBilling": "Próx. Cobro",
  "subscriptions.columnCancellation": "Fecha Cancel.",
  "subscriptions.columnGatewayId": "ID Gateway",
  "subscriptions.rowsPerPage": "Filas por página",
  "subscriptions.metricsExcludeTestNote": "Los números de abajo no incluyen suscripciones marcadas como prueba. Los valores \"en prueba\" todavía no fueron cobrados.",
  "subscriptions.metricsCounts": "Conteos",
  "subscriptions.metricsRevenue": "Ingresos",
  "subscriptions.filterIncludeTest": "Mostrar pruebas",
  "subscriptions.hiddenTestCount": "{count} suscripción(es) de prueba oculta(s) de los números y la lista.",
  "subscriptions.filterBillingPhase": "Fase",
  "subscriptions.billingPhase.trial": "En prueba",
  "subscriptions.billingPhase.active": "Cobrando",
  "subscriptions.testChip": "Prueba",
  "subscriptions.trialChip": "En prueba",

  "subscriptionDetail.title": "Detalles de la Transacción",
  "subscriptionDetail.visitorInfo": "Información del Visitante",
  "subscriptionDetail.phone": "Teléfono",
  "subscriptionDetail.transactionData": "Datos de la Transacción",
  "subscriptionDetail.type": "Tipo",
  "subscriptionDetail.product": "Producto",
  "subscriptionDetail.cycle": "Ciclo",
  "subscriptionDetail.value": "Valor",
  "subscriptionDetail.purchaseDate": "Fecha de Compra",
  "subscriptionDetail.nextBilling": "Próximo Cobro",
  "subscriptionDetail.cancellation": "Cancelación",
  "subscriptionDetail.technicalDetails": "Detalles Técnicos",
  "subscriptionDetail.internalTransactionId": "ID de Transacción (interno)",
  "subscriptionDetail.externalId": "ID Externo (MP)",
  "subscriptionDetail.gatewayPaymentId": "Gateway Payment ID",
  "subscriptionDetail.subscriptionExternalId": "Subscription External ID",
  "subscriptionDetail.historyTitle": "Historial de Transacciones del Visitante",
  "subscriptionDetail.noDataFound": "No se encontraron datos para esta transacción.",
  "subscriptionDetail.type.subscription": "Suscripción",
  "subscriptionDetail.type.singlePurchase": "Compra única",
  "subscriptionDetail.cycle.monthly": "Mensual",
  "subscriptionDetail.cycle.annual": "Anual",
  "subscriptionDetail.status.approved": "Aprobado",
  "subscriptionDetail.status.pending": "Pendiente",
  "subscriptionDetail.status.rejected": "Rechazado",
  "subscriptionDetail.status.cancelled": "Cancelado",
  "subscriptionDetail.status.superseded": "Reemplazado",
  "subscriptionDetail.testChip": "Suscripción de prueba",
  "subscriptionDetail.trialChip": "En período de prueba",
  "subscriptionDetail.markAsTest": "Marcar como prueba",
  "subscriptionDetail.unmarkAsTest": "Quitar marca de prueba",
  "subscriptionDetail.testMarkedBy": "Marcado como prueba por {name} el {date}",
  "subscriptionDetail.testFlagUpdateSuccess": "Marca de prueba actualizada.",
  "subscriptionDetail.testFlagUpdateError": "No se pudo actualizar la marca de prueba.",
  // Auditoría
  "auditLogs.title": "Auditoría",
  "auditLogs.tabActivities": "Actividades",
  "auditLogs.tabRequests": "Solicitudes",
  "auditLogs.when": "Cuándo",
  "auditLogs.who": "Quién",
  "auditLogs.what": "Qué hizo",
  "auditLogs.entity": "Entidad",
  "auditLogs.entityId": "ID",
  "auditLogs.method": "Método",
  "auditLogs.route": "Ruta",
  "auditLogs.statusCode": "Estado",
  "auditLogs.duration": "Duración",
  "auditLogs.filterUser": "Quién",
  "auditLogs.filterCategory": "Categoría",
  "auditLogs.filterAction": "Acción",
  "auditLogs.filterDateFrom": "Desde",
  "auditLogs.filterDateTo": "Hasta",
  "auditLogs.filterButton": "Filtrar",
  "auditLogs.placeholderEmail": "E-mail del usuario",
  "auditLogs.empty": "Ningún registro encontrado",
  "auditLogs.selectCategoryFirst": "Seleccione una categoría primero",
  "auditLogs.allActions": "Todas las acciones",
  "auditLogs.sessionExpired": "Sesión expirada. Inicie sesión de nuevo.",
  "logoModels.title": "Mis modelos",
  "logoModels.subtitle": "Conjuntos de logos guardados para este establecimiento",
  "logoModels.empty": "Aún no hay modelos guardados",
  "logoModels.noEstablishment": "Establecimiento no identificado en esta transmisión",
  "logoModels.saveAsModel": "Guardar como modelo",
  "logoModels.saveAsModelTitle": "Guardar como modelo",
  "logoModels.nameLabel": "Nombre del modelo",
  "logoModels.nameRequired": "Ingrese un nombre",
  "logoModels.logosRequired": "Agregue al menos un logo antes de guardar como modelo",
  "logoModels.created": "Modelo creado",
  "logoModels.updated": "Modelo actualizado",
  "logoModels.deleted": "Modelo eliminado",
  "logoModels.createTitle": "Nuevo modelo",
  "logoModels.renameTitle": "Renombrar modelo",
  "logoModels.createHint": "El modelo se creará con los logos configurados en esta transmisión.",
  "logoModels.apply": "Aplicar",
  "logoModels.rename": "Renombrar",
  "logoModels.delete": "Eliminar",
  "logoModels.deleteTitle": "¿Eliminar modelo?",
  "logoModels.deleteConfirm": "¿Seguro que desea eliminar el modelo \"{name}\"? Los logos de la transmisión no se modificarán.",
  "logoModels.applied": "Modelo aplicado",
  "logoModels.logoCount": "{count, plural, one {# logo} other {# logos}}",
  "logoModels.newModel": "Nuevo modelo",
  "logoModels.suggestTitle": "Reutilizar logos",
  "logoModels.suggestBody": "El último modelo usado en esta cancha fue \"{name}\". ¿Desea reutilizarlo?",
  "logoModels.suggestReuse": "Reutilizar",
  "logoModels.suggestChooseOther": "Elegir otro",
  "logoModels.suggestSetupManually": "Configurar manualmente",
};
